<template>
  <section id="contact" class="cta-section">
    <v-container class="section-container">
      <div class="cta-card">
        <v-row align="center" justify="space-between">
          <!-- Левая колонка: Оффер и преимущества -->
          <v-col cols="12" md="6" class="cta-info">
            <span class="cta-tag">Персональная презентация</span>
            <h2 class="cta-title">
              Закажите демонстрацию возможностей OZO.direct
            </h2>
            <p class="cta-description">
              Покажем на реальных кейсах, как сервис окупает себя в первые 30
              дней работы, сокращает расходы на комиссии и увеличивает повторные
              заказы гостей.
            </p>

            <div class="cta-benefits">
              <div class="benefit-row">
                <div class="benefit-icon-box">
                  <i class="ri-calculator-line"></i>
                </div>
                <div>
                  <strong>Индивидуальный расчет:</strong> покажем экономию на
                  комиссиях доставки для вашего заведения.
                </div>
              </div>
              <div class="benefit-row">
                <div class="benefit-icon-box">
                  <i class="ri-timer-flash-line"></i>
                </div>
                <div>
                  <strong>Быстрый запуск:</strong> настроим и передадим готовое
                  приложение в App Store и Google Play за 7 рабочих дней.
                </div>
              </div>
              <div class="benefit-row">
                <div class="benefit-icon-box">
                  <i class="ri-customer-service-2-line"></i>
                </div>
                <div>
                  <strong>Прямая связь:</strong> наш менеджер сразу ответит в
                  WhatsApp, отправит презентацию и ответит на любые технические
                  вопросы.
                </div>
              </div>
            </div>

            <!-- Быстрый переход в 1 клик -->
            <div class="direct-action mt-8">
              <v-btn
                x-large
                rounded
                elevation="0"
                class="btn-whatsapp-direct"
                :href="quickWhatsAppUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="ri-whatsapp-line mr-2 whatsapp-cta-icon"></i>
                Связаться в WhatsApp в 1 клик
              </v-btn>
              <span class="direct-hint mt-2">
                Номер: +7 (701) 722-46-66 • Время ответа: до 15 минут
              </span>
            </div>
          </v-col>

          <!-- Правая колонка: Форма для формирования готового обращения в WhatsApp -->
          <v-col cols="12" md="5" class="cta-form-col">
            <div class="form-wrapper">
              <h3 class="form-title">Связаться с нами</h3>
              <p class="form-subtitle">
                Укажите данные вашего заведения, и мы сразу сформируем готовое
                сообщение в WhatsApp:
              </p>

              <v-form
                ref="contactForm"
                v-model="valid"
                @submit.prevent="openWhatsAppWithDetails"
              >
                <v-text-field
                  v-model="form.name"
                  label="Ваше имя"
                  placeholder="Например, Александр"
                  outlined
                  dense
                  :rules="[rules.required]"
                  class="custom-field"
                ></v-text-field>

                <v-text-field
                  v-model="form.phone"
                  label="Номер телефона"
                  placeholder="+7 (___) ___-__-__"
                  outlined
                  dense
                  :rules="[rules.required, rules.phone]"
                  class="custom-field"
                  @input="handlePhoneInput"
                  @keydown="handlePhoneKeyDown"
                  @focus="onPhoneFocus"
                ></v-text-field>

                <v-text-field
                  v-model="form.restaurant"
                  label="Название ресторана / кофейни"
                  placeholder="Например, Cafe Bellagio"
                  outlined
                  dense
                  :rules="[rules.required]"
                  class="custom-field"
                ></v-text-field>

                <v-text-field
                  v-model="form.city"
                  label="Город"
                  placeholder="Например, Алматы"
                  outlined
                  dense
                  class="custom-field"
                ></v-text-field>

                <v-btn
                  block
                  x-large
                  rounded
                  elevation="0"
                  type="submit"
                  class="btn-submit-whatsapp"
                >
                  <i class="ri-whatsapp-line mr-2 whatsapp-cta-icon"></i>
                  Отправить в WhatsApp
                </v-btn>

                <p class="privacy-note">
                  При нажатии откроется чат WhatsApp с готовым текстом заявки.
                </p>
              </v-form>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "CtaSection",
  data() {
    return {
      phoneTarget: "77017224666",
      valid: false,
      form: {
        name: "",
        phone: "+7 ",
        restaurant: "",
        city: "",
      },
      rules: {
        required: (v) => !!v || "Обязательное поле",
        phone: (v) => {
          if (!v) return "Обязательное поле";
          const digits = v.replace(/\D/g, "");
          if (digits.length < 11) {
            return "Введите полный номер (11 цифр)";
          }
          return true;
        },
      },
    };
  },
  computed: {
    quickWhatsAppUrl() {
      const defaultText =
        "Здравствуйте! Мне интересны подробности возможностей сервиса Ozo.direct.";
      return `https://api.whatsapp.com/send?phone=${
        this.phoneTarget
      }&text=${encodeURIComponent(defaultText)}`;
    },
  },
  methods: {
    formatPhone(val) {
      if (!val) return "+7 ";
      let digits = val.replace(/\D/g, "");
      if (!digits) return "+7 ";

      if (digits[0] === "8") {
        digits = "7" + digits.slice(1);
      } else if (digits[0] !== "7") {
        digits = "7" + digits;
      }

      digits = digits.slice(0, 11);

      if (digits.length === 1) {
        return "+7 ";
      }

      let res = "+7 (" + digits.substring(1, Math.min(4, digits.length));
      if (digits.length > 4) {
        res += ") " + digits.substring(4, Math.min(7, digits.length));
      } else if (digits.length === 4) {
        res += ") ";
      }

      if (digits.length > 7) {
        res += "-" + digits.substring(7, Math.min(9, digits.length));
      } else if (digits.length === 7) {
        res += "-";
      }

      if (digits.length > 9) {
        res += "-" + digits.substring(9, 11);
      } else if (digits.length === 9) {
        res += "-";
      }

      return res;
    },
    handlePhoneInput(val) {
      this.form.phone = this.formatPhone(val);
    },
    handlePhoneKeyDown(e) {
      const input = e.target;
      if (!input) return;

      // Защищаем фиксированный префикс "+7 " от случайного удаления
      if (
        (e.key === "Backspace" || e.key === "Delete") &&
        input.selectionStart <= 3 &&
        input.selectionEnd <= 3
      ) {
        e.preventDefault();
        return;
      }

      // При Backspace перед спецсимволами ")", "-", " " удаляем саму цифру
      if (
        e.key === "Backspace" &&
        input.selectionStart === input.selectionEnd
      ) {
        const pos = input.selectionStart;
        const charBefore = this.form.phone[pos - 1];
        if (charBefore === " " || charBefore === "-" || charBefore === ")") {
          e.preventDefault();
          const digits = this.form.phone.slice(0, pos - 1).replace(/\D/g, "");
          const afterDigits = this.form.phone.slice(pos).replace(/\D/g, "");
          const combined = digits.slice(0, -1) + afterDigits;
          this.form.phone = this.formatPhone(combined.length ? combined : "7");
        }
      }
    },
    onPhoneFocus(e) {
      if (!this.form.phone || this.form.phone.trim() === "+7") {
        this.form.phone = "+7 ";
      }
      this.$nextTick(() => {
        const input = e && e.target ? e.target : null;
        if (input && input.setSelectionRange) {
          const len = input.value.length;
          input.setSelectionRange(len, len);
        }
      });
    },
    openWhatsAppWithDetails() {
      if (!this.$refs.contactForm.validate()) return;

      const messageParts = [
        "Здравствуйте!",
        `Меня зовут ${this.form.name.trim()}.`,
      ];

      if (this.form.restaurant) {
        messageParts.push(`Заведение: ${this.form.restaurant.trim()}.`);
      }
      if (this.form.city) {
        messageParts.push(`Город: ${this.form.city.trim()}.`);
      }
      if (this.form.phone) {
        messageParts.push(`Контактный телефон: ${this.form.phone.trim()}.`);
      }

      messageParts.push(
        "Хочу заказать демонстрацию сервиса OZO.direct и узнать условия подключения."
      );

      const fullMessage = messageParts.join(" ");
      const url = `https://api.whatsapp.com/send?phone=${
        this.phoneTarget
      }&text=${encodeURIComponent(fullMessage)}`;

      window.open(url, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.cta-section {
  background-color: $color-graphite-dark;
  padding: $section-py 0;
  position: relative;

  @media (max-width: 960px) {
    padding: $section-py-mobile 0;
  }
}

.section-container {
  max-width: $container-max-width;
  margin: 0 auto;
}

.cta-card {
  background: $color-graphite;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: $radius-lg;
  padding: 50px 40px;

  @media (max-width: 600px) {
    padding: 32px 20px;
  }

  @media (max-width: 480px) {
    padding: 24px 16px;
  }
}

.cta-info {
  color: $color-text-light;
}

.cta-tag {
  display: inline-block;
  color: $color-neon-green;
  background: rgba(0, 230, 118, 0.12);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 6px 14px;
  border-radius: $radius-full;
  margin-bottom: 16px;
}

.cta-title {
  font-family: $font-family-heading;
  font-size: 36px;
  font-weight: 800;
  color: $color-text-light;
  margin-bottom: 16px;
  line-height: 1.2;

  @media (max-width: 960px) {
    font-size: 26px;
  }
}

.cta-description {
  font-size: 16px;
  color: #94a3b8;
  line-height: 1.6;
  margin-bottom: 28px;
}

.cta-benefits {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .benefit-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: 14px;
    color: #e2e8f0;
    line-height: 1.5;

    .benefit-icon-box {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(0, 230, 118, 0.12);
      border: 1px solid rgba(0, 230, 118, 0.25);
      color: $color-neon-green;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      flex-shrink: 0;
      margin-top: 2px;
    }
  }
}

.direct-action {
  display: flex;
  flex-direction: column;

  .btn-whatsapp-direct {
    background-color: $color-neon-green !important;
    color: $color-graphite !important;
    font-weight: 800;
    font-size: 15px;
    text-transform: none;
    letter-spacing: 0;
    height: 54px !important;
    box-shadow: $shadow-neon !important;
    transition: all 0.2s ease;
    align-self: flex-start;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 28px rgba(0, 230, 118, 0.45) !important;
    }

    @media (max-width: 600px) {
      align-self: stretch;
      font-size: 13.5px;
      padding: 0 14px !important;
    }

    .whatsapp-cta-icon {
      font-size: 22px;
      color: $color-graphite;
    }
  }

  .direct-hint {
    font-size: 12px;
    color: #94a3b8;
  }
}

.form-wrapper {
  background: #ffffff;
  border-radius: $radius-md;
  padding: 36px 28px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);

  @media (max-width: 480px) {
    padding: 24px 16px;
  }
}

.form-title {
  font-family: $font-family-heading;
  font-size: 22px;
  font-weight: 800;
  color: $color-text-dark;
  margin-bottom: 6px;
}

.form-subtitle {
  font-size: 13px;
  color: $color-text-secondary;
  margin-bottom: 22px;
  line-height: 1.5;
}

.btn-submit-whatsapp {
  background-color: $color-neon-green !important;
  color: $color-graphite !important;
  font-weight: 800;
  font-size: 15px;
  text-transform: none;
  letter-spacing: 0;
  height: 52px !important;
  box-shadow: $shadow-neon !important;
  margin-top: 8px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(0, 230, 118, 0.45) !important;
  }

  .whatsapp-cta-icon {
    font-size: 22px;
    color: $color-graphite;
  }
}

.privacy-note {
  font-size: 12px;
  color: $color-text-secondary;
  text-align: center;
  margin-top: 14px;
  margin-bottom: 0;
}
</style>
